// @ts-nocheck

import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { type ExternalLinkOptions } from '../../../actions/externallink';
import { getRedirectUrl, RedirectServices } from '../../../config/urls';
import { KLRounds, type KLRound } from '../types/round';

import KLRule from './common/KLRule';
import KLViewWrapper from './common/KLViewWrapper';

type KLRoundRulesProps = {
  className?: string;
  roundId: KLRound;
  openExternalLink: (url: string, options?: ExternalLinkOptions) => void;
  rulesConfig: {
    title: string;
    rules: Array<unknown>;
  };
};

const StyledKLViewWrapper = styled(KLViewWrapper)`
  padding: 0;

  ::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;

    background: inherit;
    filter: blur(4px);
  }
`;

const InnerWrapper = styled.div`
  display: flex;
  flex: 1;
  height: 100%;

  align-items: center;
  justify-content: center;
  padding: 1em;
`;

const KLRoundRules = ({ className, rulesConfig, roundId, openExternalLink }: KLRoundRulesProps) => {
  const dispatch = useDispatch();

  const onVideoTutorialClick = useCallback(() => {
    if (roundId === KLRounds.T_RED) {
      dispatch(openExternalLink(getRedirectUrl(RedirectServices.KL_T_RED_VIDEO_TUTORIAL)));
    }

    if (roundId === KLRounds.T_WHITE) {
      dispatch(openExternalLink(getRedirectUrl(RedirectServices.KL_T_WHITE_VIDEO_TUTORIAL)));
    }

    if (roundId === KLRounds.ORIENTATION) {
      dispatch(openExternalLink(getRedirectUrl(RedirectServices.KL_ORIENTATION_VIDEO_TUTORIAL)));
    }

    if (roundId === KLRounds.POLE) {
      dispatch(openExternalLink(getRedirectUrl(RedirectServices.KL_POLE_VIDEO_TUTORIAL)));
    }
  }, [roundId, dispatch, openExternalLink]);

  return rulesConfig ? (
    <StyledKLViewWrapper className={className} viewType={roundId}>
      <InnerWrapper>
        <KLRule {...rulesConfig} openExternalLink={openExternalLink} onVideoTutorialClick={onVideoTutorialClick} />
      </InnerWrapper>
    </StyledKLViewWrapper>
  ) : null;
};

export default KLRoundRules;
